<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <h3>REPORTE TALONARIOS DE TRANSBORDADOR</h3>
                    </div>
                    <div class="col-6 text-right">
                        <button class="btn btn-primary btn-icon" @click="cargar_datos"><i class="fas fa-filter"></i> Filtrar</button>
                        <button class="btn btn-success btn-icon" @click="exportar_excel"><i class="fas fa-file-excel"></i> Excel</button>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col">
                        <table class="table table-bordered">
                            <tr class="background-light">
                                <th>RANGO DE FECHAS</th>

                            </tr>
                            <tr>
                                <td>
                                    <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div class="row mt-1" v-show="datos.length > 0">
                    <div class="col">
                            <div class="tableFixHead" style="width:100%">
                                <table class="table table-bordered">
                                    <thead class="">
                                        <tr>
                                            <th class="fixed-1 thead-skyblue2 text-center" v-for="c in columnas" :key="c.label" v-show="c.show">
                                                {{c.label}}
                                            </th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        <tr v-for="d in datos" :key="d.id" v-bind:class="{'background-light':d.seleccionado == 1}">
                                            
                                            <td class="text-center" v-for="c in columnas" :key="c.label" v-show="c.show" @click="d.seleccionado == 1?d.seleccionado= 0:d.seleccionado=1">
                                                



                                                <span v-if="c.tipo == 'number'">
                                                    {{ devuelve_valor(d,c.path,c.tipo)| formatear_miles}}
                                                </span>

                                                <span v-if="c.tipo == 'string' || c.tipo == 'datetime' || c.tipo == 'date' || c.tipo=='time'">
                                                    {{devuelve_valor(d,c.path,c.tipo)}}
                                                </span>

                                                <span v-if="c.tipo == 'html'" v-html="devuelve_valor(d,c.path,c.tipo)"></span>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        fechas:[],
        todos:true,
        columnas:[
            //{show:true,label:'Fecha Ticket',tipo:'datetime',path:'fecha_hora_ticket'},
            {show:true,label:'Patente',tipo:'string',path:'patente'},
            {show:true,label:'Folio Inicial',tipo:'string',path:'folio_inicial'},
            {show:true,label:'Folio Final',tipo:'string',path:'folio_final'},
            {show:true,label:'Utilizados',tipo:'string',path:'utilizados'},
            {show:true,label:'Restantes',tipo:'string',path:'restantes'},
            {show:true,label:'Folios Usados',tipo:'html',path:'html_folios_usados'},
            {show:true,label:'Folios Usados Otras Patentes',tipo:'html',path:'html_folios_usados_otras_patentes'},

            /* {show:true,label:'Hora Ticket',tipo:'time',path:'hora_ticket'},
            {show:true,label:'N° Ticket',tipo:'string',path:'codigo_ticket'},
            {show:true,label:'Fecha Guía (Salida Origen)',tipo:'datetime',path:'fecha_guia'},
            {show:true,label:'N° Guía',tipo:'string',path:'numero_guia'},
            {show:true,label:'Declaracion Jurada',tipo:'string',path:'declaracion_jurada'},
            {show:true,label:'CAM',tipo:'string',path:'cam'},
            {show:true,label:'Empresa',tipo:'string',path:'empresa'},
            {show:true,label:'Sucursal',tipo:'string',path:'sucursal'},
            {show:true,label:'Materia Prima',tipo:'string',path:'materia_prima'},
            {show:true,label:'Especie',tipo:'string',path:'especie'},
            {show:true,label:'Producto',tipo:'string',path:'producto'},
            {show:true,label:'Restriccion',tipo:'string',path:'restricciones'},
            {show:true,label:'Patente',tipo:'string',path:'patente'},
            {show:true,label:'Tiempo Camion en Planta',tipo:'string',path:'tiempo_camion_planta'},
            {show:true,label:'Cantidad Bins',tipo:'number',path:'cantidad_bins'},
            {show:true,label:'Peso Informado Guía (kg)',tipo:'number',path:'peso_informado_guia'},
            {show:true,label:'Peso Recibido Guía (Romana) (Kg)',tipo:'number',path:'peso_real_guia'},
            {show:true,label:'Destino Distribución',tipo:'string',path:'destino_distribucion'},
            {show:true,label:'Peso Distribucion (Kg)',tipo:'number',path:'peso_real_distribucion'}, */

        ],

        datos:[],
        url_excel:null,
        cabeceritas : '',
    }),
    mounted(){
        this.cargar_datos();
    },
    methods:{

        async cargar_datos(){
                let body = {
                    columnas:this.columnas.filter(c => c.show == true).map((c)=>{
                        return {
                            cabecera:c.label,
                            path:c.path,
                            tipo:c.tipo
                        }
                    }),
                }
                /* if(this.empresas_id.length > 0){
                    body.empresas_id = this.empresas_id;
                } */
                
                if(this.fechas[0] != null && this.fechas[0] != undefined){
                    body.desde = this.fechas[0];
                    body.hasta = this.fechas[1];
                }
                await this.axios.get(`${this.api}/reportes/taloranios_transbordadores`,this.cabeceras_json).then(res=>{
                    console.log(res.data.data);
                    this.datos = res.data.data.data;
                    this.url_excel = res.data.data.url_excel;
                    
                }).catch(e=>{
                    //console.log(e);
                });
            //}
            
        },

        async exportar_excel(){
            window.open(this.url_excel, '_blank');
        },

        devuelve_valor(item,path,tipo_dato){
          let keys = path.split('.');
          let valor = item;
          keys.forEach(k => {
                for (var key in valor) {
                  if(key == k){
                    valor = valor[key];
                  }
                }
                  
          });
          if(tipo_dato == 'datetime'){
            valor = this.$options.filters.fecha_hora(valor);
          }
          if(tipo_dato == 'date'){
            valor = this.$options.filters.fecha(valor);
          }
          if(tipo_dato == 'time'){
            valor = this.$options.filters.hora(valor);
          }
          return valor;
        },

        

        setearTodos(){
            this.columnas.forEach(c => {
                c.show = this.todos;
            });
        },

        
    },
    computed:{

        ...mapState(['api','api_public','cabeceras_json','token'])
    }
}
</script>
<style>
.tableFixHead          { overflow: auto; height: 600px; border: 1px solid rgb(212, 212, 212);}
/*.tableFixHead thead th { position: sticky; top: 0; z-index: 100; }*/

.fixed{
    position: sticky; top: 0; z-index: 100;
}

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
/*th     { background:#427391; color:#fff }*/
.margen-1{
    margin: 0em 0.5em;
}

</style>